import FactoryComponents from '../../../../factory/components/FactoryComponents.js';
import {getAlluser} from '@/api/processManager'
import {batchBindRole, getAllRole} from '@/api/companyManager'

const root = {}
export default root
root.name = 'userManager';

root.data = {
	titleName: '',
	//当前账号针对用户的权限
	thisUserAuthorize: {
		add: false,
		edit: false,
		look: false,
	},
	userDataList: {
		userDataTable: [{
				title: '名称',
				key: 'nickname',
				// width: 120,
			},
			{
				title: '账号',
				key: 'account',
				// width: 160,
			},
			{
				title: '邮箱',
				key: 'email',
				// width: 160,
			},
			{
				title: '电话',
				key: 'cellphone',
				// width: 160,
			},
			{
				title: 'IMEI',
				key: 'imei',
				// width: 160,
			},
			{
				title: '状态',
				slot: 'status',
				// width: 100,
			},
			{
				title: '角色',
				slot: 'role',
			},
			// {
			// 	title: '部门',
			// 	slot: 'dept',
			// },
			{
				title: '操作',
				slot: 'action',
				minWidth: 120,
			}
		],
		userData: {
			//数据
			data: [],
			//总页数
			total: 1,
			//当前页数
			thisPage: 1,
			//每页多少行
			limit: 10,
			//模糊查询字符串
			blurStr: '',
			//添加用户数据,
			startAddUser: {
				showStartAddUser: false,
				addUserDataCache: {}
			},
			//编辑用户数据,
			startEditUser: {
				showStartEditUser: false,
				editUserDataCache: {},
				editUserRoleCache:null,
				editUserDeptCache:[],
				deptData: [],
				roleData: [],
			},
		},
  },
  rules: {
    nickname: [
      { required: true, message: '请输入名称', trigger: 'blur' },
      // { min: 8, max: 11, message: '长度在 8 到 11 个字符', trigger: 'change' }
    ],
    account: [
      { required: true, message: '请输入账号', trigger: 'blur' },
      // { min: 6, max: 11, message: '长度在 6 到 11 个字符', trigger: 'blur' },
    ],
    pass: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      // { min: 6, max: 11, message: '长度在 6 到 11 个字符', trigger: 'blur' }
    ],
    confirmPass: [
      { required: true, message: '请输入名称', trigger: 'blur' },
      // { min: 6, max: 11, message: '长度在 6 到 11 个字符', trigger: 'blur' },
      // { validator: validatePass2, trigger: 'blur' }
    ],
	},
	// 批量绑定角色的东西
	userList: [],
	bindRoleVisible: false,
	bindRoleForm: {},
	roleList: []
};

root.mounted = function() {
	// this.userInforInit();
	this.selectUserData(1)
	this.getAlluser()
	this.getAllRole()
};

root.methods = {

	//初始化用户数据
	userInforInit: function(page) {
		let menuDatas = this.componentsMoudel.getData(this.$route.path);
		this.titleName = menuDatas.menuName;
		const userMenu = this.componentsMoudel.getData('/companyManager/userManager');
		if (userMenu) {
			userMenu.childMenu.forEach((item, index) => {
				if (item.menuName === '新建') {
					this.thisUserAuthorize.add = item.hasAuth;
				}

				if (item.menuName === '查看') {
					if (item.hasAuth) {
						this.selectUserData(1);
					}
					this.thisUserAuthorize.look = item.hasAuth;
				}
				if (item.menuName === '编辑') {
					this.thisUserAuthorize.edit = item.hasAuth;
				}

			});
		}
	},
	//查询用户数据
	selectUserData(page) {
		const that = this;
		let formdata = new FormData();
		formdata.append("account", this.userDataList.userData.blurStr);
		formdata.append("curPage", page);
		formdata.append("limit", this.userDataList.userData.limit);
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').searchUserByName)
			.openLoad().startPost(formdata).then((res) => {
				that.userDataList.userData.data = res.body.data === null ? [] : res.body.data;
				that.userDataList.userData.total = res.body.cum;
				that.userDataList.userData.thisPage = res.body.page;
			});
	},

	// 获取所有用户
	getAlluser() {
		getAlluser().then(res => {
			this.userList = res.body.data
		})
	},

	// 获取所有角色
	getAllRole() {
		getAllRole().then(res => {
			this.roleList = res.body.data
		})
	},


	//根据角色列表返回界面显示
	filterRoleList: function(roles) {
		const roleArray = [];
		// const roleArray = "";
		if(roles != null){
			roles.forEach((item, index) => {
				if (item !== null) {
					roleArray.push(item);
				}
			})
    }
		return roleArray;
	},

	//根据部门列表返回界面显示
	// filterDeptList: function(depts) {
	// 	const deptArray = [];
	// 	if(depts != null){
	// 		depts.forEach((item, index) => {
	// 			if (item !== null) {
	// 				deptArray.push(item);
	// 			}
	// 		})
	// 	}
	// 	return deptArray;
	// },

	//添加用户
	addUserOk: function() {
		// if (this.userDataList.userData.startAddUser.addUserDataCache.nickname === undefined) {
		// 	this.$message({
		// 		message: '请输入名称',
		// 		type: 'error'
		// 	});
		// 	return;
		// }
		// if (this.userDataList.userData.startAddUser.addUserDataCache.account === undefined) {
		// 	this.$message({
		// 		message: '请输入账号',
		// 		type: 'error'
		// 	});
		// 	return;
		// }
		// if (this.userDataList.userData.startAddUser.addUserDataCache.pass === undefined) {
		// 	this.$message({
		// 		message: '请输入密码',
		// 		type: 'error'
		// 	});
		// 	return;
    // }
    this.$refs['ruleForm'].validate((valid) => {
      if(valid){
        if (this.userDataList.userData.startAddUser.addUserDataCache.pass !==
          this.userDataList.userData.startAddUser.addUserDataCache.confirmPass) {
          this.$message({
            message: '两次密码不一致',
            type: 'error'
          });
          return;
        }
        const that = this;
        let formdata = new FormData();
        formdata.append("account", this.userDataList.userData.startAddUser.addUserDataCache.account);
        formdata.append("nickname", this.userDataList.userData.startAddUser.addUserDataCache.nickname);
        formdata.append("password", this.userDataList.userData.startAddUser.addUserDataCache.pass);
        this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').addUserData)
          .openLoad().startPost(formdata).then((res) => {
            that.userDataList.userData.startAddUser.addUserDataCache = {};
            that.userDataList.userData.startAddUser.showStartAddUser = false;
            that.selectUserData(that.userDataList.userData.thisPage);
          });
      }else{
        this.$message.error('请填写必填项')
      }
    })
	},

  // 弹窗关闭的事件
  modalClose(val) {
    if(!val) {
      this.$refs['ruleForm'].resetFields()
    }
	},
	bindRoleVisibleChange(val) {
		if(!val) {
			this.bindRoleForm = {}
		}
	},


	//取消添加用户
	addUserCancel: function() {
		this.userDataList.userData.startAddUser.addUserDataCache = {};
		this.userDataList.userData.startAddUser.showStartAddUser = false;
	},

	//禁用用户
	userDisable: function(item){
		const that = this;
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').userDisable+'/'+item.id)
			.openLoad().startDel().then((res) => {
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				that.selectUserData(that.userDataList.userData.thisPage);
			});
  },

  // 删除用户
  delUserData: function(item) {
    const that = this;
    this.$confirm(`确认删除 ${item.nickname}`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      that.componentsMoudel.getRequestHander(that.componentsMoudel.getData('urls').delUserData + '/' + item.id)
      .openLoad().startDel().then((res) => {
        this.$message.success('删除成功')
        that.selectUserData(that.userDataList.userData.thisPage);
      })
    })
  },

	//重置用户密码
	resetUserPass: function(item){
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').resetUserPass+'/'+item.id)
			.openLoad().startPut().then((res) => {
				this.$message({
					message: '重置成功',
					type: 'success'
				});
			});
	},
	//开始编辑用户
	startEditUser: function(userData){
		const that = this;
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').getUserDataAllInfo+'/'+userData.id)
			.openLoad().startGet().then((res) => {
				// that.userDataList.userData.startEditUser.deptData = [...res.body.data.notHasDep, ...res.body.data.hasDep];
				that.userDataList.userData.startEditUser.roleData = [...res.body.data.hasNotRole, ...res.body.data.hasRole];
				// res.body.data.hasDep.forEach((item, index)=>{
				// 	that.userDataList.userData.startEditUser.editUserDeptCache.push(item.id);
				// });
				// res.body.data.hasRole.forEach((item, index)=>{
				// 	that.userDataList.userData.startEditUser.editUserRoleCache.push(item.id);
        // });
        if(res.body.data.hasRole.length > 0) {
          that.userDataList.userData.startEditUser.editUserRoleCache = res.body.data.hasRole[0].id // 这是新加的
        }
				that.userDataList.userData.startEditUser.showStartEditUser = true;
				that.userDataList.userData.startEditUser.editUserDataCache = {...userData};
			});

	},
	//取消添加用户
	editUserCancel: function() {
		this.userDataList.userData.startEditUser.editUserDataCache = {};
		this.userDataList.userData.startEditUser.showStartEditUser = false;
		// this.userDataList.userData.startEditUser.roleData = [];
		this.userDataList.userData.startEditUser.roleData = "";
		this.userDataList.userData.startEditUser.deptData = [];
		// this.userDataList.userData.startEditUser.editUserDeptCache = [];
		this.userDataList.userData.startEditUser.editUserRoleCache = null;
		// this.userDataList.userData.startEditUser.editUserRoleCache = [];
	},

	editUserOk: function(){
		if(this.userDataList.userData.startEditUser.editUserDataCache.nickname === '' ||
			this.userDataList.userData.startEditUser.editUserDataCache.nickname === null){
				this.$message({
					message: '请输入名称',
					type: 'error'
				});
				return;
		}
    const that = this;
		// const roles = JSON.stringify(this.userDataList.userData.startEditUser.editUserRoleCache);
    // const depts = JSON.stringify(this.userDataList.userData.startEditUser.editUserDeptCache);
		let roles=[];
		if(this.userDataList.userData.startEditUser.editUserRoleCache){
			roles = JSON.stringify([this.userDataList.userData.startEditUser.editUserRoleCache]); // 这是新加的
		}
		let formdata = new FormData();
		formdata.append("nickname", this.userDataList.userData.startEditUser.editUserDataCache.nickname);
		formdata.append("account", this.userDataList.userData.startEditUser.editUserDataCache.account);
		formdata.append("cellphone", this.userDataList.userData.startEditUser.editUserDataCache.cellphone);
		formdata.append("email", this.userDataList.userData.startEditUser.editUserDataCache.email);
		formdata.append("imei", this.userDataList.userData.startEditUser.editUserDataCache.imei);
		formdata.append("croleEntities", roles);
		// formdata.append("departmentEntities", depts);
		formdata.append("id", this.userDataList.userData.startEditUser.editUserDataCache.id);
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').editUserData)
			.openLoad().startPut(formdata).then((res) => {
				that.editUserCancel();
				that.selectUserData(that.userDataList.userData.thisPage);
			});
	},


	// 批量绑定角色的事件
	bindRoleOk() {
		let obj = {
			roleId: this.bindRoleForm.roleId,
			userList: []
		}
		this.bindRoleForm.userList.forEach(v => {
			obj.userList.push({ id: v })
		})
		batchBindRole({ ...obj }).then(res => {
			this.$message.success('绑定成功')
			this.selectUserData(1)
			this.bindRoleVisible = false
		})
	},
};

FactoryComponents.initComponent(root);
